import React, {Component} from 'react';
import AccordionContent from '../AccordionContent/AccordionContent';
import AccordionTrigger from '../AccordionTrigger/AccordionTrigger';

export default class AccordionSection extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <section className={"accordion__section " + (this.props.isActive ? "open" : "")}>
                <AccordionTrigger handleClick={this.props.handleClick}
                                  isActive={this.props.isActive}
                                  content={this.props.accordionTrigger}
                                  index={this.props.index} />
                <AccordionContent isActive={this.props.isActive}
                                  content={this.props.accordionContent}
                                  index={this.props.index} />
            </section>
        );
    }
}